/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { IQuotaConfig } from 'generated-types';
import { QuotaConfig } from 'object-types';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { SharedModule } from 'ng/shared/shared.module';

import './license-quota-config.component.less';
import * as l10n from './license-quota-config.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for license quota configuration.
 * @author Suraj Kumar
 */
@Component({
    selector: 'license-quota-config',
    templateUrl: './license-quota-config.component.html',
    standalone: true,
    imports: [
        SharedModule,
        AviFormsModule,
    ],
})
export class LicenseQuotaConfigComponent {
    /**
     * License Quota Configuration.
     */
    @Input()
    public config: IQuotaConfig;

    public readonly objectType = QuotaConfig;

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
